<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 表单选择 -->
    <div class="form-inquire bg-white mgt-20 pdt-10 ">
      <!-- = -->
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="订单编号">
          <el-input
            v-model="form.orderNo"
            clearable
            placeholder="请输入订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input
            v-model="form.equipmentNum"
            placeholder="请输入设备编号"
            clearable
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="订单归属">
          <el-select
            filterable
            multiple
            v-model="form.customerName"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in guishuqiye"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="支付类型">
          <el-select
            multiple
            v-model="form.payType"
            placeholder="全部"
            clearable
          >
            <el-option label="电子水卡" value="1"></el-option>
            <el-option label="实物水卡" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- = -->
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="用戶电话">
          <el-input
            v-model="form.phone"
            placeholder="请输入用户电话"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="水卡编号">
            <el-input
              v-model="form.cardNum"
              placeholder="请输入水卡编号"
              clearable
            ></el-input>
          </el-form-item> -->
        <el-form-item label="所属分区">
          <el-select
            multiple
            filterable
            v-model="form.fenqu"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @input="$forceUpdate()"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="mgl-10">
          <el-button
            type="primary"
            class="mgr-20"
            @click="
              getinquireOrder();
              getorderAll();
            "
            >查询</el-button
          >
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- = -->
    </div>

    <!-- 数据 -->
    <div class="mgt-20">
      <div class="flex ">
        <div class="flex fw-600  color052173 mgr-200">
          <span class="mgr-20">合计订单数（笔）：{{ orderNum }}</span>
          <span class="mgr-20">合计订单金额（元）：¥{{ orderMoney }}</span>
          <span>合计购水量(L)：{{ allWaterNum }}</span>
        </div>
      </div>
      <div class="flex jcsb">
        <!-- <el-button v-if="roleId !== 23" class="mgt-20" @click="goafterOrder"
              >售后订单</el-button
            > -->
        <btns @exec="exec"></btns>
      </div>
    </div>

    <!-- 表格 -->
    <div class="mgt-20">
      <el-table
        :data="tableData"
        style="width: 100%"
        stripe
        border
        :cell-style="cellStayle"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
        <!-- <el-table-column prop="payNo" label="支付流水号">
            <template slot-scope="scope">
              <span v-text="scope.row.payNo ? scope.row.payNo : '- -'"></span>
            </template>
          </el-table-column> -->
        <!-- <el-table-column prop="userNum" label="用户编号"> </el-table-column> -->
        <!-- <el-table-column prop="waterCard" label="水卡编号">
            <template slot-scope="scope">
              <span
                v-text="scope.row.waterCard ? scope.row.waterCard : '- -'"
              ></span>
            </template>
          </el-table-column> -->

        <el-table-column prop="phone" label="用户电话">
          <template slot-scope="scope">
            <span v-text="scope.row.phone ? scope.row.phone : '- -'"></span>
          </template>
        </el-table-column>
        <el-table-column prop="equipmentNum" label="设备编号">
        </el-table-column>
        <el-table-column prop="payType" label="支付类型">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.payType === 2
                  ? '微信'
                  : scope.row.payType === 1
                  ? '电子水卡'
                  : '实物水卡'
              "
            ></span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="customerName" label="订单归属">
        </el-table-column> -->
        <el-table-column prop="regionName" label="所属分区"> </el-table-column>

        <el-table-column prop="sceneName" label="订单来源"> </el-table-column>
        <el-table-column prop="waterType" label="购水类型">
          <!-- <template slot-scope="scope">
                <span
                  v-text="
                    scope.row.waterType == 1
                      ? '常温/热水'
                      : scope.row.waterType == 3
                      ? '冰水'
                      : '--'
                  "
                ></span>
              </template> -->
        </el-table-column>
        <el-table-column prop="chushuiliang" label="购水量"> </el-table-column>
        <el-table-column prop="realWater" label="实际出水量">
          <template slot-scope="scope">
            <span
              v-text="scope.row.realWater ? scope.row.realWater : '暂无数据'"
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="realTime" label="实际接水时间（秒）">
          <template slot-scope="scope">
            <span
              v-text="scope.row.realTime ? scope.row.realTime : '暂无数据'"
            ></span>
          </template>
        </el-table-column>

        <el-table-column prop="orderPrice" label="订单金额(元)">
        </el-table-column>
        <!-- <el-table-column prop="walletDiscountPrice" label="优惠金额(元)">
            </el-table-column> -->
        <el-table-column prop="refundPrice" label="退款金额(元)">
          <template slot-scope="scope">
            <span v-text="scope.row.refundPrice"></span>
          </template>
        </el-table-column>
        <el-table-column prop="payPrice" label="消费金额(赠送/实付)">
          <template slot-scope="scope">
            <span
              v-text="
                (
                  Number(scope.row.payPrice) +
                  Number(scope.row.walletDiscountPrice)
                ).toFixed(2) +
                  '（' +
                  scope.row.walletDiscountPrice +
                  '/' +
                  scope.row.payPrice +
                  '）'
              "
            ></span>
          </template>
        </el-table-column>

        <el-table-column prop="isError" label="订单上报时间">
          <template slot-scope="scope">
            <span v-text="'######'"></span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="state" label="订单状态">
              <template slot-scope="scope">
                <span
                  v-text="
                    scope.row.state == 2
                      ? '待消费'
                      : scope.row.state == 3
                      ? '已消费'
                      : '已取消'
                  "
                ></span>
              </template>
            </el-table-column> -->
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 导出弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportVisible"
      width="30%"
      center
      :close-on-click-modal="false"
    >
      <div class="mgb-10">温馨提示:不填写条件则导出全部</div>
      <el-form
        :rules="exportFormRules"
        ref="exportForm"
        :model="exportForm"
        label-width="80px"
      >
        <el-form-item label="归属企业">
          <el-select
            multiple
            clearable
            filterable
            v-model="exportForm.qiye"
            placeholder="全部"
          >
            <el-option
              v-for="(v, i) in guishuqiye"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付类型">
          <el-select
            multiple
            clearable
            v-model="exportForm.type"
            placeholder="全部"
          >
            <el-option label="微信" value="2"></el-option>
            <el-option label="电子水卡" value="1"></el-option>
            <el-option label="实物水卡" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否退款">
          <el-select clearable v-model="exportForm.isRefund" placeholder="全部">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易时间">
          <div class="flex">
            <el-date-picker
              v-model="exportForm.startTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="exportForm.endTime"
              :picker-options="pickerOptionsEnd8"
              format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- <el-form-item label="页码" prop="pageNum">
              <el-input
                v-model="exportForm.pageNum"
                placeholder="请输入页码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="每页条数" prop="pageSize">
              <el-input
                v-model="exportForm.pageSize"
                placeholder="请输入每页条数"
                clearable
              ></el-input>
            </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportBtn('exportForm')"
          >导 出</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import store from "../../store";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    const pageNum = (rule, value, callback) => {
      // var reg = /^\d{0,7}(\.\d{0,2})?$/g;
      var reg = /^[1-9]\d*$/;
      if (!value) {
        callback(new Error("请输入页码"));
      } else if (!reg.test(value)) {
        callback(new Error("仅支持正整数输入"));
      } else {
        callback();
      }
    };
    const pageSize = (rule, value, callback) => {
      // var reg = /^\d{0,7}(\.\d{0,2})?$/g;
      var reg = /^(?!0$)[1-9]\d{0,5}$/;
      if (!value) {
        callback(new Error("请输入每页条数"));
      } else if (!reg.test(value)) {
        callback(new Error("仅支持正整数输入,且最大不能超过500000条"));
      } else {
        callback();
      }
    };

    return {
      orderState: ["全部", "待消费", "已消费", "已取消"], //头部根据订单状态查看订单
      currentOrderState: "全部", //订单选择激活的状态，默认
      form: { customerName: [] }, //头部表单数据
      tableData: [], //表格数据
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      orderNum: 0,
      orderMoney: 0,
      discountPrice: 0,
      payPrice: 0,
      refundPrice: 0,
      wxPrice: 0,
      roleId: null,
      companyId: null,
      // pickerOptionsEnd: {
      //   disabledDate: (time) => {
      //     let beginDateVal = this.form.startTime;
      //     if (beginDateVal) {
      //       return time.getTime() < new Date(beginDateVal).getTime();
      //     } else {
      //       return time.getTime() < Date.now() - 8.64e7;
      //     }
      //   },
      // },
      allWaterNum: 0,
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsEnd8: {
        disabledDate: (time) => {
          let beginDateVal = this.exportForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      guishuqiye: [],
      exportVisible: false,
      exportForm: {
        qiye: [],
        type: [],
        isRefund: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 500000,
      },

      exportFormRules: {
        pageNum: [{ required: true, validator: pageNum, trigger: "blur" }],
        pageSize: [{ required: true, validator: pageSize, trigger: "blur" }],
      },
      zoneArr: [],
    };
  },
  created() {
    this.getROLE();
    // this.getGuishu();
    setTimeout(() => {
      this.getorderAll();
      this.getinquireOrder();
    }, 200);
    this.getZone();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
    "exportForm.startTime"() {
      if (this.exportForm.startTime == null) {
        this.exportForm.endTime = null;
      }
    },
  },
  methods: {
    getZone() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    exportBtn(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认导出吗?", "info")
            .then(() => {
              this.$api.order
                .xiaofeiExport({
                  companyId: this.exportForm.qiye,
                  payType: this.exportForm.type,
                  isRefund: this.exportForm.isRefund,
                  startTime: this.exportForm.startTime,
                  endTime: this.exportForm.endTime,
                  pageNum: this.exportForm.pageNum,
                  pageSize: this.exportForm.pageSize,
                })
                .then((res) => {
                  handleAlert("导出成功", "success");
                  this.exportVisible = false;
                  const link = document.createElement("a");
                  link.style.display = "none";
                  link.href = URL.createObjectURL(res);
                  link.setAttribute("download", "消费订单.xls");
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    export() {
      this.exportVisible = true;
      this.exportForm = {
        qiye: [],
        type: [],
        isRefund: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 500000,
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.exportForm.clearValidate();
      });
    },
    getGuishu() {
      if (this.roleId == 21) {
        this.$api.shebei.sellQiyePull().then((res) => {
          this.guishuqiye = res.data;
          // this.guishuqiye.unshift({ companyName: "运营平台", id: 146 });
        });
      } else {
        this.$api.enterprise.enterpriseListPullNew().then((res) => {
          this.guishuqiye = res.data;
          // this.guishuqiye.unshift({ companyName: "运营平台", id: 146 });
        });
      }
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    // 获取订单数据
    getorderAll() {
      // this.guishuqiye.forEach((v) => {
      //   if (v.companyName === this.form.customerName) {
      //     this.companyId = v.id;
      //   }
      // });
      let arr = [];
      this.guishuqiye.forEach((v) => {
        arr.push(v.id);
      });
      this.$api.order
        .orderDataAllNew({
          companyId:
            this.form.customerName.length > 0 ? this.form.customerName : arr,
          endTime: this.form.endTime,
          equipmentNum: this.form.equipmentNum,
          isError: this.form.isError,
          isRefund: this.form.isRefund,
          orderNo: this.form.orderNo,
          payType: this.form.payType,
          phone: this.form.phone,
          payNo: this.form.payNo,

          scene: this.form.scene,
          startTime: this.form.startTime,
          userNum: this.form.userId,
          waterCard: this.form.cardNum,
          regionId: this.form.fenqu,
        })
        .then((res) => {
          this.allWaterNum = res.data.waterNum;
          this.orderNum = res.data.orderNum;
          this.orderMoney = res.data.orderPrice;
          this.refundPrice = res.data.refundPrice;
          this.payPrice = res.data.payPrice;
          this.discountPrice = res.data.discountPrice;
          this.wxPrice = res.data.wxPrice;
        });
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.roleId = token.roleId;
      }
    },
    // 重置
    reset() {
      this.form = { fenqu: [], customerName: [] };
      this.getinquireOrder();
      this.getorderAll();
    },
    // 查询订单
    getinquireOrder(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.guishuqiye.forEach((v) => {
        if (v.companyName === this.form.customerName) {
          this.companyId = v.id;
        }
      });
      let arr = [];
      this.guishuqiye.forEach((v) => {
        arr.push(v.id);
      });

      this.$api.order
        .inquireOrder({
          pageNum: this.page,
          pageSize: this.pageSize,
          payNo: this.form.payNo,
          companyId:
            this.form.customerName.length > 0 ? this.form.customerName : arr,
          endTime: this.form.endTime,
          equipmentNum: this.form.equipmentNum,
          isError: this.form.isError,
          isRefund: this.form.isRefund,
          orderNo: this.form.orderNo,
          payType: this.form.payType,
          phone: this.form.phone,
          scene: this.form.scene,
          startTime: this.form.startTime,
          userNum: this.form.userId,
          waterCard: this.form.cardNum,
          regionId: this.form.fenqu,
        })
        .then((res) => {
          if (res.code === 200) {
            const phoneReg = /^(\d{3})\d{4}(\d{4})$/;
            this.tableData = res.data.rows;
            this.total = res.data.total;
            this.tableData.forEach((v, i) => {
              let obj = JSON.parse(v.equipmentSku);
              v.chushuiliang = obj.出水量;
              v.waterType = obj.type;
              if (v.phone) {
                v.phone = v.phone.replace(phoneReg, "$1****$2");
              }
            });
          }
        });
    },
    // 根据订单状态选择相对应的订单
    handClickState(item) {
      this.currentOrderState = item;
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 根据条件判断字段颜色
    cellStayle(row, colum, rowIndex, columnIndex) {
      if (row.row.isError && row.columnIndex == 19) {
        return "color:red";
      } else if (!row.row.abnormal && row.columnIndex == 19) {
        return;
      } else {
        return;
      }
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getinquireOrder(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getinquireOrder(this.page);
    },
    // 表格查看订单详情按钮事件
    // lookDeatils(row) {
    //   if (row.isError) {
    //     this.$router.push({
    //       path: "/order/orderLists/spentDeatils_have",
    //       query: {
    //         orderNo: row.orderNo,
    //       },
    //     });
    //   } else if (row.state == 3 && row.isError == false) {
    //     this.$router.push("/order/orderLists/spentDeatils_no");
    //   } else if (row.state == 2) {
    //     this.$router.push("/order/orderLists/unconsumedDetails");
    //   } else {
    //     this.$router.push("/order/orderLists/canceledDetails");
    //   }
    // },
    lookDeatils(row) {
      this.$router.push({
        path: "/order/orderLists/spentDeatils_have",
        query: {
          orderNo: row.orderNo,
        },
      });
    },
    // 点击售后订单按钮跳转到售后订单页面
    goafterOrd() {
      this.$router.push("/order/newAfterOrder");
    },
  },
};
</script>

<style lang="scss" scoped>
// 根据订单状态查看订单
.orderStateSelect {
  padding: 10px 50px;
  background: var(--card-bg);
  border: 2px solid var(--input-border);
  cursor: pointer;
  margin-right: 50px;
}
.orderStateSelect-active {
  padding: 10px 50px;
  background: var(--accent);
  border: 2px solid var(--accent);
  color: #fff;
  cursor: pointer;
  margin-right: 50px;
}
// 表单
.form-inquire {
  .el-date-editor,
  .el-input,
  .el-select {
    width: 200px;
  }
  .el-date-editor {
    margin-right: 10px;
  }
  /deep/ .el-form-item__label {
    color: var(--text-main);
  }
}
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
// 打水是否异常，如异常字为红色
/deep/.el-table .tr-red {
  color: red !important;
}
</style>
